import React, { useEffect, useState } from "react";
import "./FormBody.scss"

// Components //
import FormWizard from "../form-wizard/FormWizard";
import FormGroup from "../form-group/FormGroup";

interface IBodyForm {
    titulosFormulario: Array<any>;
    tituloBoton?: string;
    genericClassNameForm: string;
    setInputValue: any;
    formValues: any;
    onclick?: () => any,
    handleSubmitForm: any;
    inputDisabled: string[];
    fieldsToSkip?: string[];
    validBirthDate?: boolean;
    isDisabledButton?: boolean;
    handleEvent?: any;
    dateState?: any;
    children?: any;
    talleresData?: any;
    childHeader?: any;
    getActiveIndex?: (index: number) => void;
    setDuration?: (value: string) => void;
    handleCancelButton?: any;
    setCurrentIndex?: any;
    childOptions?: any;
    optionEdit?:boolean;
    setOptionEdit?:any;
    positionIndex?:number;
    dateStateHelper?:boolean;
    setDateStateHelper?: any;
    currentIndex?:any;
    alertMessage?:boolean;
    ageAlert?:boolean;
    setDisableStep?:any;
}

const FormBody = (props: IBodyForm) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [wizards, setWizards] = useState<any[]>([]);

    // Si hay mas de un grupo, se activa el wizard y boton VOLVER.
    const activeWizard = props.titulosFormulario.length > 1 ? true : false;

    // Crea lista de los titulos para el wizard
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < props.titulosFormulario.length; i++) {
            if (props.titulosFormulario[i]) {
                newWizards.push({
                    description: props.titulosFormulario[i].tituloGeneral,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    useEffect(() => {
        if(props.genericClassNameForm === "formulario por talento" ){
            setActiveIndex(props.currentIndex);
        }
    },[props.currentIndex])
    // const sendActiveIndex () 

    // Estado para determinar el titulo activo del wizard
    useEffect(() => {
        createWizards();
    }, [props.titulosFormulario, props.formValues]);

    useEffect(() => {
        if(activeIndex === 1) document.querySelector(".m-form-wizard")?.scrollIntoView();
        if(props.genericClassNameForm === "formulario por talento" ){
            props.setCurrentIndex(activeIndex);
        }
    }, [activeIndex])

    
    return (
        <div className="m-form-body">
              {/* Renderiza el wizard */}
            <div className="m-form-body__wizard">
                {activeWizard && props.genericClassNameForm !== "formulario por talento" && (
                    <FormWizard wizards={wizards} activeIndex={activeIndex} />
                )}
            </div>
            {/* Crea grupo el cual contiene secciones y en estas los campos/inputs. */}
            <FormGroup
                titulosFormulario={props.titulosFormulario}
                tituloBoton={props.tituloBoton}
                setActiveIndex={setActiveIndex}
                activeIndex={activeIndex}
                activeWizard={activeWizard}
                endIndex={props.titulosFormulario.length}
                setInputValue={props.setInputValue}
                formValues={props.formValues}
                handleSubmitForm={props.handleSubmitForm}
                inputDisabled={props.inputDisabled}
                fieldsToSkip={props.fieldsToSkip}
                validBirthDate={props.validBirthDate}
                isDisabledButton={!!props.isDisabledButton}
                handleEvent={props.handleEvent}
                dateState={props.dateState}
                talleresData={props.talleresData}
                onclick={props.onclick}
                childHeader={props.childHeader}
                getActiveIndex={props.getActiveIndex}
                setDuration={props.setDuration}
                handleCancelButton={props.handleCancelButton}
                setCurrentIndex={props.setCurrentIndex}
                childOptions={props.childOptions}
                optionEdit={props.optionEdit}
                setOptionEdit={props.setOptionEdit}
                positionIndex={props.positionIndex}
                dateStateHelper={props.dateStateHelper}
                setDateStateHelper={props.setDateStateHelper}
                alertMessage={props.alertMessage}
                ageAlert={props.ageAlert}
                setDisableStep={props.setDisableStep}
            />
            {props.children}
        </div>
        
    );
};

export default FormBody;
